//订单状态
export const orderStatusOption = [
  { label: "待派车", value: "1" },
  { label: "待预约", value: "2" },
  { label: "待上门", value: "3" },
  { label: "回收中", value: "4" },
  { label: "待填写车辆信息", value: "5" },
  { label: "运输中", value: "6" },
  { label: "已完成", value: "7" },
  { label: "已取消", value: "8" },
  { label: "承运商押金不足", value: "9" },
  { label: "待激活", value: "10" }
];
//当订单状态为回收中的时候 增加子状态选项
export const recyclingStatusOption = [
  { label: "未出库", value: 1 },
  { label: "物流验收中", value: 2 },
  { label: "待客户签名", value: 3 },
  { label: "待物流签名", value: 4 }
];
//旧机状态
export const oldMachineOption = [
  { label: "待网点入库", value: 10000 },
  { label: "网点已入库", value: 10100 },
  { label: "待OMS审核", value: 10101 },
  { label: "OMS审核驳回", value: 10102 },
  { label: "可申请旧机退回", value: 10103 },
  { label: "已申请旧机退回", value: 10110 },
  { label: "网点已出库", value: 10200 },
  { label: "物流已验收", value: 10201 },
  { label: "归集仓入库", value: 10301 },
  { label: "归集仓出库", value: 10302 },
  { label: "再生资源已入库", value: 10400 }
];

//工单类型
export const orderTypeOption = [
  { label: "安装", value: "1" },
  { label: "维修", value: "2" },
  { label: "清洗", value: "3" },
  { label: "拆移机", value: "4" },
  { label: "咨询", value: "5" },
  { label: "投诉", value: "6" },
  { label: "销售线索", value: "7" },
  { label: "空调租赁", value: "8" },
  { label: "退换货", value: "9" },
  { label: "回访", value: "10" },
  { label: "回收", value: "11" },
  { label: "以旧换新", value: "12" }
];
//合作方合作种类

export const partnerTypeList = [
  { label: "以旧换新-支线物流", value: "1" },
  { label: "批量回收", value: "2" }
];

//归集仓状态
export const warehouseStatus = [
  { label: "启用", value: 0 },
  { label: "停用", value: 1 }
];

//线上/线下渠道
export const salePlatformType = [
  { label: "线上渠道", value: 1 },
  { label: "线下渠道", value: 2 }
];



// WEBPACK FOOTER //
// ./src/views/oldForNewService/mixin.js